/**
 * PSR Phase 2 — tier-1 sentiment fetcher registry.
 */
import { censusAcsFetcher } from './censusAcsFetcher';
import { blsFetcher } from './blsFetcher';
import { fccFetcher } from './fccFetcher';
import { localPublicDataFetcher } from './localPublicDataFetcher';
import { localGisFetcher } from './localGisFetcher';
import { newsAggregatorFetcher } from './newsAggregatorFetcher';
import type { SentimentFetcher, SentimentFetcherSourceId } from './types';

export { censusAcsFetcher } from './censusAcsFetcher';
export { blsFetcher } from './blsFetcher';
export { fccFetcher } from './fccFetcher';
export { localPublicDataFetcher } from './localPublicDataFetcher';
export { localGisFetcher } from './localGisFetcher';
export { newsAggregatorFetcher } from './newsAggregatorFetcher';
export * from './types';
export { resolveSentimentSiteContext, hasResolvableSiteGeo } from './siteContext';

export const SENTIMENT_FETCHERS: readonly SentimentFetcher[] = [
  censusAcsFetcher,
  blsFetcher,
  fccFetcher,
  localPublicDataFetcher,
  localGisFetcher,
  newsAggregatorFetcher,
] as const;

export function getSentimentFetcher(sourceId: SentimentFetcherSourceId): SentimentFetcher | undefined {
  return SENTIMENT_FETCHERS.find(f => f.sourceId === sourceId);
}
